<template>
    <div class="flex flex-col min-h-screen px-5 bg-black bg-opacity-90 p-10 ">
        <img
            class="mx-auto pt-5"
            v-bind:src="$page.props.white_label.data.logo_black"
            width="200"
        />
        <div class="max-w-md place-self-center">
            <CustomerData v-if="showCustomerDataModal" :customer="customerData.customer" />
            <CustomerForm v-else :form.sync="form" :fetching-zip-code="fetchingZipCode" :searching-federal-document="searchingFederalDocument" />
        </div>


        <div v-if="!showCustomerDataModal" class="fixed bottom-10 place-self-center">
            <button
                :class="[valideForm ? 'bg-yellow-300' : 'bg-gray-500', 'w-52 text-xs md:text-sm font-bold py-3 px-3 md:px-6 rounded-full uppercase hover:bg-yellow-400 object-center']"
                @click="save()">
                CONFIRMAR
            </button>
        </div>
        <div v-else class="fixed bottom-10 place-self-center">
            <div class="grid grid-cols-2 gap-6 place-items-center">
                <button
                    class="col-span-1 w-36 text-xs md:text-sm font-bold py-3 px-3 md:px-6 rounded-full uppercase border-white border hover:bg-yellow-400 object-center text-white"
                    @click="refuseCustomerData">
                    NÃO, REFAZER
                </button>
                <button
                    class="col-span-1 w-32 text-xs md:text-sm font-bold py-3 px-3 md:px-6 rounded-full uppercase hover:bg-yellow-400 object-center bg-yellow-300"
                    @click="confirmCustomerData">
                    SIM
                </button>
            </div>
        </div>
    </div>
</template>
<script>

import JetFormSection from "../../Jetstream/FormSection.vue";
import JetInput from "../../Jetstream/Input.vue";
import JetMaskedInput from "../../Jetstream/MaskedInput";
import JetLabel from "../../Jetstream/Label.vue";
import _ from "lodash";
import CustomerData from "./CustomerData.vue";
import CustomerForm from "./CustomerForm.vue";

export default {
    props: ['form', 'data'],
    components: {
        CustomerForm,
        CustomerData,
        JetLabel,
        JetFormSection,
        JetInput,
        JetMaskedInput
    },
    data() {
        return {
            searchingFederalDocument: false,
            fetchingZipCode: false,
            ignoreFederalDocument: false,
            showCustomerDataModal: false,
            customerData: {}
        }
    },
    computed: {
        valideForm() {
            if (!this.form.confirm_terms) {
                return false;
            }
            if (this.form.federal_document == null || this.form.federal_document.length < 14) {
                return false;
            }

            return !(this.form.email == null || this.form.phone_number == null || this.form.address.street == null
                || this.form.occupation == null || this.form.address.neighborhood == null || this.form.address.number == null);
        }
    },
    methods: {
        refuseCustomerData(){
            this.showCustomerDataModal = false;
            this.customerData = {}
            this.form.last_id = null;
        },
        confirmCustomerData() {
            this.form.last_id =  this.customerData.last_id;
            this.save()
        },
        save() {
            if (!this.valideForm && this.form.last_id == null) {
                this.$toast.open({
                    message: 'Preencha todos os campos obrigatórios',
                    type: 'error',
                    duration: 5000,
                    position: 'top-right'
                });
                return;
            }

            this.form.post(`/pix-pdv-exchange/${this.data.id}`, {
                preserveScroll: true,
                onSuccess: () => {
                    this.form.processing = false
                },
                onError: () => {
                    this.form.processing = false
                }
            });
        },
        async searchFederalDocument() {
            if (this.ignoreFederalDocument) {
                return;
            }
            this.searchingFederalDocument = true;
            await fetch(
                `/json/pix-pdv-exchange/federal-document/${escape(this.form.federal_document.replace(/[^0-9]/g, ''))}`
            ).then(res => {
                res.json().then(json => {
                    if (json.customer.federal_document == null) {
                        return;
                    }
                    console.log(this.json);
                    this.customerData = json;
                    this.showCustomerDataModal = true;
                });
            }).finally(() => {
                this.searchingFederalDocument = false;
            })
        },
        async fetchZipCode() {
            this.fetchingZipCode = true;
            await fetch(
                `/json/pix-pdv-exchange/zip-code/${escape(this.form.address.zip_code.replace(/[^0-9]/g, ''))}`
            ).then(res => {
                res.json().then(json => {
                    if (!json.neighborhood) {
                        this.$toast.open({
                            message: 'CEP inválido. Verifique os dados e tente novamente',
                            type: 'error',
                            duration: 5000,
                            position: 'top-right'
                        });
                    }
                    this.parseAddress(json);
                });

            }).finally(() => {
                this.fetchingZipCode = false;
            })
        },
        parseAddress(address) {
            this.form.address.street = address.street || null;
            this.form.address.neighborhood = address.neighborhood || null;
            this.form.address.city = address.city || null;
            this.form.address.state = address.state || null;
        }
    },
    watch: {
        'form.federal_document': {
            handler: _.debounce(function (v) {
                if (v.length === 14) {
                    this.searchFederalDocument()
                }
            }, 200),
            deep: true
        },
        'form.address.zip_code': {
            handler: _.debounce(function (v) {
                if (v.length === 9) {
                    this.fetchZipCode()
                }
            }, 200),
            deep: true
        },
    },
}


</script>
